import axios from 'axios';

export let headers = {
  'Tenant-Access-Token': 'ZTQ2NWU4YjVmZTdkMTIzNjVlZTQxZmEwMTBkODZlOTg=',
  'Tenant-Access-Key': 'ntrfEooX8BtrSA',
};

export const BASE_URL = 'https://tiltlabs-dev.confirmu.com';

export const api = axios.create({
  baseURL: BASE_URL,
  headers: headers
});

